import type { Dayjs } from "dayjs";
import { normalizeBic,normalizeIban } from "../../../app/utils/sepa";
import type { PersonDto,UpsertPersonDto } from "../types";
import type { PersonFormValues } from "./personDetailTypes";

function nullableText(value: unknown): string | null {
  if (value == null) return null;
  const text = String(value).trim();
  return text ? text : null;
}

function nullableDate(value: Dayjs | string | null | undefined): string | null {
  if (value == null) return null;
  if (typeof value === "string") return nullableText(value);
  return value.format("YYYY-MM-DD");
}

export function buildUpsertPersonDtoFromForm(
  values: PersonFormValues,
  person: PersonDto,
  options: {
    bankName: string | null;
    canChangeHomeStudio: boolean;
  }
): UpsertPersonDto {
  return {
    firstName: nullableText(values.firstName) ?? "",
    lastName: nullableText(values.lastName) ?? "",
    title: nullableText(values.title),
    useDu: values.useDu ?? null,
    gender: values.gender ?? null,
    dateOfBirth: nullableDate(values.dateOfBirth),
    email: nullableText(values.email),
    phone: nullableText(values.phone),
    mobile: nullableText(values.mobile),
    street: nullableText(values.street),
    zip: nullableText(values.zip),
    city: nullableText(values.city),
    country: nullableText(values.country),
    bankAccountHolder: nullableText(values.bankAccountHolder),
    iban: values.iban ? normalizeIban(values.iban) : null,
    bic: values.bic ? normalizeBic(values.bic) : null,
    bankName: nullableText(options.bankName),
    mandateReference: nullableText(values.mandateReference),
    mandateSignedDate: nullableDate(values.mandateSignedDate),
    homeStudioId: options.canChangeHomeStudio
      ? nullableText(values.homeStudioId) ?? person.homeStudioId ?? null
      : person.homeStudioId ?? null,
    doNotContactMessages: values.doNotContactMessages === true,
    doNotContactCalls: values.doNotContactCalls === true
  };
}

export function buildUpsertPersonDtoFromPerson(
  person: PersonDto,
  overrides: Partial<Pick<UpsertPersonDto, "homeStudioId">> = {}
): UpsertPersonDto {
  return {
    firstName: nullableText(person.firstName) ?? "",
    lastName: nullableText(person.lastName) ?? "",
    title: nullableText(person.title),
    useDu: person.useDu ?? null,
    gender: person.gender ?? null,
    dateOfBirth: nullableText(person.dateOfBirth),
    email: nullableText(person.email),
    phone: nullableText(person.phone),
    mobile: nullableText(person.mobile),
    street: nullableText(person.street),
    zip: nullableText(person.zip),
    city: nullableText(person.city),
    country: nullableText(person.country),
    bankAccountHolder: nullableText(person.bankAccountHolder),
    iban: nullableText(person.iban),
    bic: nullableText(person.bic),
    bankName: nullableText(person.bankName),
    mandateReference: nullableText(person.mandateReference),
    mandateSignedDate: nullableText(person.mandateSignedDate),
    homeStudioId: overrides.homeStudioId ?? person.homeStudioId ?? null,
    doNotContactMessages: person.doNotContactMessages === true,
    doNotContactCalls: person.doNotContactCalls === true
  };
}
